import { render, staticRenderFns } from "./Dallas.vue?vue&type=template&id=63d60634&lang=pug&"
import script from "./Dallas.vue?vue&type=script&lang=ts&"
export * from "./Dallas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports